import ServiceBase from "base/baseService"
import { boolToNumber, } from "helper/formater"
import queryString from "query-string"

export default class CfopService extends ServiceBase {

    title = "CFOP"
    pluralTitle = "CFOPs"
    url = '/cadastro/fiscal/cfop'
    frontUrl = '/cadastro/fiscal/cfop'
    frontUrlList = '/cadastro/fiscal/cfoplist'
    primaryKey = 'codigo_cfop'
    ignoredsSchemaConvertions = ['usu_ins_cfop', 'usu_atua_cfop']

    prepareToFront(data = {}) {

        data.direito_cred_cfop = boolToNumber(data.direito_cred_cfop)
        data.calc_ipi_cfop = boolToNumber(data.calc_ipi_cfop)
        data.exige_anp_cfop = boolToNumber(data.exige_anp_cfop)
        data.st_trib_cfop = boolToNumber(data.st_trib_cfop)

        // Numéricos com FK notNullable

        // Strings notNullable

        data.descricao_cfop = data?.descricao_cfop || ''

        // Numéricos sem FK

        data.cfop_dev_cfop = data?.cfop_dev_cfop || null
        data.cfop_entrada_cfop = data?.cfop_entrada_cfop || null

        // Dependentes

        // data.cfop = data?.cfop || [] // Isso não fez sentido em Serie
        // data.tributo = data?.tributo || [] // Isso não fez sentido em Serie

        // Datas

        return data
    }

    prepareToSave({ data }) {

        return data

    }

    async listByAutoComplete(text) {

        text = (text ?? '').trim()

        if (!text) return

        const search = { page: 1, perPage: 6, type: 'autocomplete' }

        search.codigo_cfop = `${text}%`
        search.descricao_cfop = `${text}%`

        return await this.list('?' + queryString.stringify(search))

    }

}
